(function () {
    var AdvancedSearchFilter = {
        $earlyCiteCheckbox: $('#earlyCite'),
        $earlyCiteCheckboxHidden: $('#earlyCite_hidden'),
        init: function () {
            AdvancedSearchFilter.control();
        },
        control: function () {
            AdvancedSearchFilter.$earlyCiteCheckbox[0].addEventListener('change', function () {
                if (AdvancedSearchFilter.$earlyCiteCheckbox[0].checked) {
                    AdvancedSearchFilter.$earlyCiteCheckboxHidden[0].disabled = true;
                } else {
                    AdvancedSearchFilter.$earlyCiteCheckboxHidden[0].disabled = false;
                }
            });
        },
    };
    UX.AdvancedSearchFilter = AdvancedSearchFilter; // add to global namespace
})();
